export class AddFavoriteError extends Error {}
export class RemoveFavoriteError extends Error {}
